export default __webpack_public_path__ + "static/media/list_main_13_2.73422e3b.jpg";